export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/configurations/get/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/configurations',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/configurations',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/configurations/${id}`,
      data: payload,
    });
  },
});
